import {GRANITE_1, GRANITE_10} from '@gaia/colors';
import type {ControlPointState, ControlPointType} from '@gaia/utils/typing';
import tinycolor from 'tinycolor2';

export default function controlPointFactory(
    size: number,
    state: ControlPointState,
    color: string,
    type: ControlPointType
) {
    let outerCircleStyles = '',
        innerCircleStyles = '';

    const midpoint = size / 2;
    const largeRadius = size / 3;
    const smallRadius = size / 9.375;
    const thickStroke = size / 7.5;
    const thinStroke = size / 18.75;

    if (state === 'idle') {
        switch (type) {
            case 'start': {
                innerCircleStyles = `display: none;`;
                break;
            }
            case 'middle': {
                const {l} = tinycolor(color).toHsl();

                const colorDarker = tinycolor(color)
                    .darken(l * 100 * 0.25) // darken by 25%
                    .toString('hsl');
                outerCircleStyles = `stroke: ${colorDarker}; fill: ${color}`;
                innerCircleStyles = `r: ${largeRadius - thickStroke / 2}px;`;
                break;
            }
            case 'end': {
                break;
            }
        }
    } else {
        switch (type) {
            case 'start': {
                outerCircleStyles = `filter: url(#shadow-terminal);`;
                innerCircleStyles = `display: none;`;
                break;
            }
            case 'middle': {
                const {h} = tinycolor(color).toHsl();

                const highlightColor = `hsl(${h},81%,87%)`; // 81% saturation, 87% lightness; regardless of hue

                outerCircleStyles = `stroke-width: 0px; fill: ${color}; filter: url(#shadow-middle);`;
                innerCircleStyles = `r: ${largeRadius}px; stroke: ${highlightColor}; stroke-width: ${thinStroke}px; fill: none;`;
                break;
            }
            case 'end': {
                outerCircleStyles = `filter: url(#shadow-terminal);`;
                break;
            }
        }
    }

    return `<svg xmlns="http://www.w3.org/2000/svg" height="${size}px" width="${size}px" viewBox="0 0 ${size} ${size}">
    <defs>
        <filter id="shadow-terminal" filterUnits="userSpaceOnUse" x="0" y="0" width="${size}" height="${size}">
            <feDropShadow dx="0" dy="5" stdDeviation="5" flood-color="${GRANITE_1}" flood-opacity="0.5" />
        </filter>
        <filter id="shadow-middle" filterUnits="userSpaceOnUse" x="0" y="0" width="${size}" height="${size}">
            <feDropShadow dx="0" dy="5" stdDeviation="10" flood-color="black" flood-opacity="0.50" />
        </filter>
    </defs>
    <circle cx="${midpoint}" cy="${midpoint}" r="${largeRadius}" stroke="${color}" stroke-width="${thickStroke}" fill="${GRANITE_10}" style="${outerCircleStyles}"/>
    <circle cx="${midpoint}" cy="${midpoint}" r="${smallRadius}" stroke="${color}" fill="${color}" style="${innerCircleStyles}"/>
</svg>`;
}
